import { motion } from 'framer-motion';
import PageHero from '../components/PageHero';

const fadeInUp = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] }
};

export const PrivacyPage = () => {
  return (
    <div className="overflow-hidden">
      <PageHero
        badge="Legal"
        title="Privacy"
        titleAccent="Policy"
        subtitle="How we collect, use, and protect your information."
      />

      <section className="bg-white py-20 md:py-32">
        <div className="max-w-3xl mx-auto px-6 md:px-12 lg:px-24">
          <motion.div {...fadeInUp} className="prose prose-slate max-w-none">
            <p className="text-sm text-slate-500 mb-8">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
            
            <h2 className="text-2xl font-bold text-[#0F172A] mb-4">Information We Collect</h2>
            <p className="text-slate-600 mb-4">
              When you use our website, we may collect the following information:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-8">
              <li><strong>Contact form submissions:</strong> Name, email address, phone number (optional), and message content that you voluntarily provide when using our contact form.</li>
              <li><strong>Analytics data:</strong> We use Google Analytics to collect anonymous usage data such as pages visited, time on site, device type, and general location. This data is collected via cookies.</li>
              <li><strong>Chat messages:</strong> If you use our AI chat assistant, your questions and the assistant's responses are stored to improve our service.</li>
            </ul>

            <h2 className="text-2xl font-bold text-[#0F172A] mb-4">How We Use Your Information</h2>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-8">
              <li>To respond to your contact form inquiries</li>
              <li>To understand how visitors use our website so we can improve it</li>
              <li>To provide customer support through our chat feature</li>
            </ul>

            <h2 className="text-2xl font-bold text-[#0F172A] mb-4">Cookies and Tracking</h2>
            <p className="text-slate-600 mb-4">
              This website uses Google Analytics (GA4) which places cookies on your device to collect anonymous usage statistics. You can opt out of Google Analytics by installing the{' '}
              <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer" className="text-[#1E3A8A] underline">Google Analytics Opt-out Browser Add-on</a>.
            </p>
            <p className="text-slate-600 mb-8">
              We also store your language preference (English or Spanish) in your browser's local storage.
            </p>

            <h2 className="text-2xl font-bold text-[#0F172A] mb-4">Third-Party Services</h2>
            <p className="text-slate-600 mb-4">We use the following third-party services:</p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-8">
              <li><strong>Google Analytics:</strong> Website analytics. <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-[#1E3A8A] underline">Google Privacy Policy</a></li>
              <li><strong>EverWash:</strong> Membership plans and payments are managed by EverWash, Inc. When you click on membership links, you leave our site and enter EverWash's platform, which is governed by their own <a href="https://www.everwash.com/privacy" target="_blank" rel="noopener noreferrer" className="text-[#1E3A8A] underline">privacy policy</a> and <a href="https://www.everwash.com/terms" target="_blank" rel="noopener noreferrer" className="text-[#1E3A8A] underline">terms of service</a>.</li>
              <li><strong>Resend:</strong> Email delivery for contact form submissions.</li>
              <li><strong>Google Maps:</strong> Embedded maps and directions.</li>
            </ul>

            <h2 className="text-2xl font-bold text-[#0F172A] mb-4">EverWash Memberships</h2>
            <p className="text-slate-600 mb-8">
              Membership plans, pricing, payments, cancellation, and plan changes are managed entirely by EverWash, Inc. Super Spray Car Wash II is a participating wash location. For questions about billing, cancellation, or your membership account, please contact EverWash directly through the EverWash app or visit{' '}
              <a href="https://www.everwash.com" target="_blank" rel="noopener noreferrer" className="text-[#1E3A8A] underline">everwash.com</a>.
            </p>

            <h2 className="text-2xl font-bold text-[#0F172A] mb-4">Data Retention</h2>
            <p className="text-slate-600 mb-8">
              Contact form submissions and chat messages are retained to provide customer service. Google Analytics data is retained according to Google's default retention settings.
            </p>

            <h2 className="text-2xl font-bold text-[#0F172A] mb-4">Your Rights</h2>
            <p className="text-slate-600 mb-8">
              You may request deletion of your contact form data or chat history by emailing us at{' '}
              <a href="mailto:superspray2@icloud.com" className="text-[#1E3A8A] underline">superspray2@icloud.com</a>{' '}
              or calling us at <a href="tel:9182079463" className="text-[#1E3A8A] underline">918-207-9463</a>.
            </p>

            <h2 className="text-2xl font-bold text-[#0F172A] mb-4">Contact</h2>
            <p className="text-slate-600 mb-4">
              If you have questions about this privacy policy, contact us at:
            </p>
            <p className="text-slate-600">
              Super Spray Car Wash II<br />
              1581 S Muskogee Ave, Tahlequah, OK 74464<br />
              Phone: <a href="tel:9182079463" className="text-[#1E3A8A] underline">918-207-9463</a><br />
              Email: <a href="mailto:superspray2@icloud.com" className="text-[#1E3A8A] underline">superspray2@icloud.com</a>
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPage;
